<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
  <path stroke="#000" d="M2.5 14.5v7h19v-19h-7v6h-6v6h-6z"/>
</svg>
